export class EstoqueRequest {
  produtoId:  number | null = null;
  quantidade: number = 0;
}
